import { useEffect } from "react";
import Lenis from "lenis";
import { gsap, ScrollTrigger, prefersReducedMotion } from "../../lib/gsap";

/**
 * Lenis driven by GSAP's ticker — one loop, so ScrollTrigger never samples a
 * stale scroll position (no pin jump, no marker drift). Never add a separate
 * requestAnimationFrame loop for Lenis alongside this.
 */
const SmoothScroll = ({ children }) => {
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);

    // Reduced motion: native scroll only. ScrollTrigger still works.
    if (prefersReducedMotion()) return undefined;

    const lenis = new Lenis({
      lerp: 0.085,
      wheelMultiplier: 1,
      touchMultiplier: 1.6,
      smoothWheel: true,
    });

    window.lenis = lenis;

    const onScroll = () => ScrollTrigger.update();
    const tick = (time) => lenis.raf(time * 1000);

    lenis.on("scroll", onScroll);
    gsap.ticker.add(tick);
    gsap.ticker.lagSmoothing(0);

    // Webfonts change line breaks and therefore every trigger position.
    document.fonts?.ready.then(() => ScrollTrigger.refresh());

    const onResize = () => {
      lenis.resize();
      ScrollTrigger.refresh();
    };
    window.addEventListener("resize", onResize);

    return () => {
      window.removeEventListener("resize", onResize);
      gsap.ticker.remove(tick);
      gsap.ticker.lagSmoothing(500, 33);
      lenis.off("scroll", onScroll);
      lenis.destroy();
      if (window.lenis === lenis) delete window.lenis;
    };
  }, []);

  return children;
};

export default SmoothScroll;
